export const tableInputClass = `
  bg-secondary text-secondary-foreground 
  ml-auto h-6 w-fit 
  [appearance:textfield] 
  px-2 
  text-right text-base 
  shadow-none 
  not-focus:text-base 
  focus:text-base focus-visible:ring-0 
  disabled:bg-transparent disabled:text-base disabled:opacity-100 
  [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none 
  data-error:border-destructive
`;
